const fetchUtil = async (url, options) =>
  new Promise((resolve, reject) => {
    fetch(url, options)
      .then(res => {
        if (!res.ok) {
          return reject(res);
        }

        return res.json ? res.json() : res;
      })
      .then(data => resolve(data))
      .catch(err => {
        reject(err);
      });
  });

export default fetchUtil;
